/**
 * Design System - Skeleton Atom
 * Base skeleton component with pulse animation
 * Used as building block for all skeleton placeholders
 */

<script setup>
defineProps({
  width: {
    type: String,
    default: '100%'
  },
  height: {
    type: String,
    default: '1rem'
  },
  borderRadius: {
    type: String,
    default: 'var(--radius-sm)'
  }
})
</script>

<template>
  <div
    class="skeleton"
    :style="{
      width,
      height,
      borderRadius
    }"
    role="status"
    aria-label="Carregando..."
  />
</template>

<style scoped>
.skeleton {
  display: block;
  background-color: var(--color-background-neutral, #f0f0f0);
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* SYN-2738 (A14): sem pulsar com prefers-reduced-motion (o bloco cinza já comunica "carregando"). */
@media (prefers-reduced-motion: reduce) {
  .skeleton {
    animation: none;
  }
}
</style>
